// src/components/Navbar.js
import React from "react";
import "./Navbar.css";
import logo from "../assets/logo.png";
import omhausImage from "../assets/OmHaus_LOGO.png"; // Add your omHaus image

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-image">
          <img src={omhausImage} alt="omHaus" className="omhaus-img" />
        </div>
        <div className="nav-logo">
          <a href="#" className="logo-link">
            <img src={logo} alt="Logo" className="logo-img" />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
